import script from "./ClockPriceingDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClockPriceingDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./ClockPriceingDrawer.vue?vue&type=style&index=0&id=472dacc6&lang=scss"

const __exports__ = script;

export default __exports__